module.exports = __webpack_public_path__ + "img/terminal-explained.a759e25f.jpg";